
































import { Search } from '@/data/models/search.model';
import store, { State } from '@/store';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class NoteFilter extends Vue {

    @Prop() actorid!: number;
    @Prop() entity!: string;

	advancedSearch: Search;
	searchParam: any = new class {
		note?: string;
	};
	state!: State;

	constructor() {
		super();
		this.state = store;
		this.advancedSearch = new Search('note');
	}

	@Watch('actorid') 
	onActoridChange() {
		if(this.actorid) {
			this.search();
		}
	}

	search() {
		this.advancedSearch.reset();
		this.advancedSearch.addSimpleFilter('entity', this.entity);
		this.advancedSearch.addSimpleFilter('actorid', this.actorid);
		if (this.searchParam.note) this.advancedSearch.addLikeFilter('note', this.searchParam.note);
		this.$emit('search', this.advancedSearch);
	}

	reset() {
		this.searchParam.note = undefined;
		this.search();
	}
}
